<template>
	<div>
		<!-- <el-card>
			<el-form :model="form" ref="form" :inline="true">
				<el-form-item label="订单编号:">
					<el-input placeholder="请输入订单编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
                
				<el-form-item label="状态:">
					<el-select v-model="form.state" placeholder="请选择状态">
						<el-option label="充值统计" value="0"></el-option>
						<el-option label="支出统计" value="1"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="流水日期:">
                    <el-date-picker
                        v-model="form.time"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
				
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
					<el-button @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
			
		</el-card> -->

		<!-- <WriterMoney  :items="writerMoney" /> -->
		
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				
				<el-table-column prop="id" label="编号" >
				</el-table-column>
				<el-table-column prop="start_time" label="交易时间" >
				</el-table-column>
				<el-table-column prop="username" label="申请人" >
				</el-table-column>
				
                <el-table-column prop="price" label="金额" >
				</el-table-column>
				
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import WriterMoney from '../../components/board/commentWriter'
	import {
		getCopyRightList
	} from '../../api/board.js'
	export default {
		components: {
			Pageing,
			WriterMoney
		},
		data() {
			return {
                pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
				formLabelWidth: '120px',
				
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					orderid: '',
					time: '',
                    name:'',
					state:''
				},
				
				forminfo:{},
				writerMoney:[],
			};
		},
		mounted() {
			//const queryParams = this.$route.query;
			
			// if(queryParams){
			// 	console.log(`output->queryParams`,queryParams)
			// 	this.form.name =queryParams.name
			// }
			// console.log(`output->this.form.name`,this.form.name)
			this.getuserlist()
		},
		computed: {
			isincome(e){
				console.log(e);
				return true;
			}
		},
		methods: {
            
			resetForm(){
				this.form.orderid =''
				this.form.time =''
                this.form.name =''
				this.form.state =''
				this.getuserlist()
			},
			getuserlist(){
				getCopyRightList({
					page:this.page,
					where:this.form,
                    //type:"all"
				}).then(res=>{
					this.tableData = res.data
					this.total = res.total 
					this.writerMoney = res.writerMoney 
				})
			},
			
			submitForm() {
				this.page = 1
				this.getuserlist()
			},
            gofinduser(val){
                this.form.name = val
                this.getuserlist()
            },
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
	
</style>
